module.exports = __webpack_public_path__ + "img/purpleCarnival.e279bc44.png";